// react
import { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import axios, { AxiosResponse } from "axios";
// mui
import {
  Button,
  useTheme,
  PopoverOrigin,
  IconButton,
  Popover,
  Typography,
} from "@mui/material";
// src
import { config } from "../../config/config";
import FormatUtil from "../Utility/ProjectComUtil";
import { ProjectDetailContext } from "../../pages/ProjectDetail";
import { Common } from "../../../common/src";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import CoordinateSystemDialog from "./Dialogs/CoordinateSystemDialog";
import CoordinateContext, { EDataType } from "./Contexts/CoordinateContext";

const CoordinateSystem = (props: any) => {
  const {
    styleKey,
    styleColon,
    styleValue,
    buttonSx,
    jobsiteName,
    showDialog,
  } = props;
  const { projectDetail, isDialogType } = useContext(ProjectDetailContext);
  const { t } = useTranslation();
  const {
    fetchCS,
    localizedStorageData,
    storageData,
    currentType,
    setStorageData,
    setLocalizedStorageData,
    dashboardData,
    fetchDashboardCS,
  } = useContext(CoordinateContext);

  /*****************************************
    state
  ******************************************/
  const [isShowCoordinateSystemPopup, setIsShowCoordinateSystemPopup] =
    useState(false);
  // EPSG又はステレオパラメータの判定
  // const [showFlag, setShowFlag] = useState<boolean>(false);

  // const [dashboardData, setDashboardData] = useState<any>(undefined);

  // const fetchDashboardCS = async () => {
  //   return await axios
  //     .get(
  //       `${config.serverHost}/api/v1/project/${projectDetail?.id}/coordinate-system/dashboard`,
  //       { withCredentials: true }
  //     )
  //     .then((res: AxiosResponse<any>) => {
  //       // ステレオパラメータの場合 TRUE
  //       if (res.data.conditionFlag) setShowFlag(true);
  //       setDashboardData(res.data);
  //       return res.data;
  //     })
  //     .catch((e) => {
  //       console.error(e);
  //       return undefined;
  //     });
  // };

  // useEffect(() => {
  //   // 座標系ボタンを押下した場合
  //   if (isDialogType === "PROJECT_DETAIL") {
  //     fetchCS(projectDetail?.id);
  //     fetchDashboardCS(projectDetail?.id);
  //   }
  // }, [isDialogType]);

  useEffect(() => {
    showDialog(isShowCoordinateSystemPopup);
  }, [isShowCoordinateSystemPopup]);

  const handleOpen = () => {
    setIsShowCoordinateSystemPopup(true);
  };

  const theme = useTheme();

  const customColor = {
    color: theme.palette.base.contrast,
  };

  type CustomPopoverProps = {
    anchorOrigin: PopoverOrigin;
    transformOrigin: PopoverOrigin;
  };
  const CustomPopover = ({
    anchorOrigin,
    transformOrigin,
  }: CustomPopoverProps) => {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const stylePopKey: React.CSSProperties = {
      width: "120px",
      color: customColor.color,
      fontSize: "14px",
      overflowWrap: "break-word",
      wordWrap: "break-word",
    };

    const stylePopValue: React.CSSProperties = {
      color: customColor.color,
      fontSize: "14px",
      overflowWrap: "break-word",
      wordWrap: "break-word",
    };

    return (
      <span style={{ marginLeft: "10px" }}>
        <IconButton onClick={handleClick} style={{ padding: 0 }}>
          <FontAwesomeIcon icon={faCircleExclamation} style={customColor} />
        </IconButton>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={anchorOrigin}
          transformOrigin={transformOrigin}
        >
          <Typography sx={{ p: 2 }}>
            {localizedStorageData.map((item) => {
              return (
                <div style={{ display: "flex" }}>
                  <div style={stylePopKey}>{item.left}</div>
                  <div style={styleColon}>:</div>
                  <div style={stylePopValue}>
                    {Number(
                      FormatUtil.removeDecimalPoint(Number(item.right), 5)
                    )}
                  </div>
                </div>
              );
            })}
          </Typography>
        </Popover>
      </span>
    );
  };

  return (
    <>
      {currentType === EDataType.LOCALIZE &&
      localizedStorageData &&
      localizedStorageData.length > 0 ? (
        <div style={{ display: "flex" }}>
          <div style={styleKey}>{t("COORDINATE_SYSTEM")}</div>
          <div style={styleColon}>:</div>
          <div style={styleValue}>
            {t("COORDINATE_SYSTEM_JOBSITE")}({jobsiteName})
            <CustomPopover
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            />
          </div>
          <div style={buttonSx}>
            <Button
              size="small"
              variant="contained"
              onClick={handleOpen}
              style={{
                boxShadow: "none",
                borderRadius: "5px",
              }}
            >
              {t("CHANGES")}
            </Button>
          </div>
        </div>
      ) : (
        <>
          {storageData.map((item) => {
            return (
              <div key={item.id} style={{ display: "flex" }}>
                <div style={styleKey}>{item.left}</div>
                <div style={styleColon}>:</div>
                {item.right !== "" &&
                item.right !== null &&
                item.right !== undefined ? (
                  <div style={styleValue}>{item.right}</div>
                ) : (
                  <div style={styleValue}>{t("COORD_SYSTEM_NO_INFO")}</div>
                )}
                {item.id === "horizontal" && (
                  <div style={buttonSx}>
                    <Button
                      size="small"
                      variant="contained"
                      onClick={handleOpen}
                      style={{
                        boxShadow: "none",
                        borderRadius: "5px",
                      }}
                    >
                      {t("CHANGES")}
                    </Button>
                  </div>
                )}
              </div>
            );
          })}
        </>
      )}
      {isShowCoordinateSystemPopup && (
        <CoordinateSystemDialog
          // storageData={storageData}
          // setStorageData={setStorageData}
          // localizedStorageData={localizedStorageData}
          // setLocalizedStorageData={setLocalizedStorageData}
          // dashboardData={dashboardData}
          // setDashboardData={setDashboardData}
          // showFlag={showFlag}
          // setShowFlag={setShowFlag}
          // currentType={currentType}
          open={isShowCoordinateSystemPopup}
          close={() => setIsShowCoordinateSystemPopup(false)}
        />
      )}
    </>
  );
};

export default CoordinateSystem;
